class TagFilter extends HTMLSelectElement {
  constructor() {
    super();

    this.beforeInit();
    this.addEventListener('change', this.onChange);
  }

  beforeInit() {
    const value = this.options[this.selectedIndex].text;
    const width = theme.getElementWidth(this, value);
    this.style.setProperty('--width', `${width}px`);
  }

  onChange() {
    window.location.href = this.value;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.blog-search input[type="search"]');
  if (!searchInput) return;

  const articles = document.querySelectorAll('.article-card');
  if (!articles.length) return;

  const searchInputHandler = () => {
    const searchTerm = searchInput.value.toLowerCase();
    articles.forEach(article => {
      const titleElement = article.querySelector('.product-card__title');
      if (titleElement) {
        const title = titleElement.textContent.toLowerCase();
        article.style.display = title.includes(searchTerm) ? '' : 'none';
      }
    });
  };

  searchInput.addEventListener('input', searchInputHandler);
});
